module.exports = __webpack_public_path__ + "static/media/ic_success_blue.28d7e6fb.svg";